<div class="play-activity">
    <div class="count-header">
        <div class="count-header-item">
            <div class="header">Play Activity</div>
            <div class="subtitle">Last 7 Days</div>
        </div>
        <div class="count-header-item eyeball">
            <button
                class="button-eyeball"
                id="testerThing"
                mat-icon-button
                (click)="viewDetails()"
                matTooltip="View Details"
                aria-label="View Details"
                type="button">
                <fa-icon icon="eye" />
            </button>
        </div>
    </div>
    <r1-compass-app-activity-counts [counts]="totalCounts" />
    <div class="play-activity-chart">
        <r1-compass-app-counts-bar-chart [chartData]="chartData" [colors]="colors" />
    </div>
</div>
